// import { useContext } from "react";
import { 
	// AboutUsContacts, 
	AboutUsContainer, AboutUsImg, AboutUsInfo, AboutUsText, AboutUsWrapper, SmokeEffect, TT } from "./about-us.styles";

import AboutService from '../../assets/img/about-us.jpg';
// import Button from "../button/button.component";
// import externalLink from '../../assets/icons/icon-external-link-blue.svg'
// import smokeEffect from '../../assets/img/smoke-left-min.png';
import sec_bg_img from '../../assets/img/opacity-logo.webp';
// import { Link } from "react-scroll";
// import { LanguageContext } from "../../contexts/language.context";
import yt from '../../assets/img/yt.svg';
import tt from '../../assets/img/tt.svg';
import iconExternalLink from '../../assets/icons/icon-external-link_blue.svg';
import "./styles.scss"


const AboutUs =({props})=>{

	return(
		<AboutUsWrapper className="about-us">
			<SmokeEffect>
				<img src={sec_bg_img} alt="" style={{ maxWidth: 450 }} className="mers"/>
			</SmokeEffect>
			<AboutUsContainer>
				<AboutUsImg>
					<img src={AboutService} alt="" />
				</AboutUsImg>
				<AboutUsInfo>
					<AboutUsText>
						<h2 id="about-us">{props[1]}</h2>
						<p>{props[2]}</p>
						<p>{props[9]}</p>
						<p>{props[10]}</p>
						<p>{props[11]}</p>
						{/* <h2 id="products">{props[3]}</h2>
						<p>{props[4]}<span> {props[4.1]} </span> {props[4.2]}</p>
						<h2>{props[5]}</h2>
						<p>{props[6]}</p> */}
					</AboutUsText>
					<div className="links-wrapper">

					{/* <a className="link-item" target="_blank" href={'https://www.youtube.com/watch?v=8ElJGBW7Brs&t=4401s&ab_channel=OneDayTV'}> */}
						{/* <img src={yt} alt="YouTube"/> */}
					{/* </a> */}
					{/* <TT> */}

					{/* <a className="link-item" target="_blank" href={'https://www.tiktok.com/@tudorelsoltan?_t=ZM-8u1hVUumOxD&_r=1'}>
						<img src={tt} alt="YouTube"/>
					</a> */}
					{/* </TT> */}
					<a className="link-item see-more" target="_blank" href="https://docs.google.com/document/d/1QBWPARghWoVdCTGG1OPgOQccjSQWjJdvmi25zRfp8jo/edit?usp=sharing">
						{props[12]}<img src={iconExternalLink} alt=""/></a>
					{/* <AboutUsContacts>
						<Link to="form" spy={true} smooth={true} offset={0} duration={500}>
							<Button children={props[7]}/>
						</Link>
						<a rel="noreferrer" target='_blank' href="https://docs.google.com/document/d/1YJpYhOyVK7dvbNsJK8R1sQcQOcPYZSyBv4UecnTto-k/edit">
							<button className="purpleBtn">
								<span>{props[8]}</span>
								<img src={externalLink} alt=""/>
							</button>
						</a>
					</AboutUsContacts> */}
					</div>
				</AboutUsInfo>
			</AboutUsContainer>
			
		</AboutUsWrapper>
	)
}

export default AboutUs;